import { useState, useRef } from "react";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { handleCustomResponse } from "../../utils/response";
import { parsePhoneNumberFromString } from "libphonenumber-js";
const CustomPhoneInput = ({
  name,
  control,
  errors,
  defaultCountry = "SA",
  label = "Phone Number *",
  placeholder = "Enter phone number",
  onChange: externalOnChange,
  labelName = true,
  countryCode=false,
}) => {
  const [phoneData, setPhoneData] = useState({ phone: "", isValid: false });
  const [toastShown, setToastShown] = useState(false);
  const previousCountryRef = useRef(defaultCountry.toLowerCase());
let countryCodeFromStorage = localStorage.getItem("country_code");
// Agar localStorage me null, "null", "" ya undefined ho, defaultCountry use karo
const invalidValues = [null, "null", "", undefined];
const initialCountry = invalidValues.includes(countryCodeFromStorage)
  ? defaultCountry.toLowerCase()
  : countryCodeFromStorage.toLowerCase();
  return (
    <>
      <style>{`/* =============================================
   CUSTOM PHONE INPUT STYLING
   ============================================= */
/* Label Styling */
.form-label {
  display: block;
  font-family: var(--default-font, sans-serif);
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-primary-light);
  margin-bottom: var(--size-8);
}
/* Base styling for the phone input wrapper */
.phone-input-container .react-tel-input {
  font-family: var(--default-font, sans-serif);
}
/* Input Field Styling */
.phone-input-container .form-control {
  width: 100% !important;
  height: 45px !important;
  font-size: var(--font-sm) !important;
  background-color: var(--input-bg) !important;
  color: var(--text-primary-light) !important;
  border: 1px solid var(--input-stroke) !important;
  border-radius: 0 var(--rounded-8) var(--rounded-8) 0 !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
/* Country Dropdown Button */
.phone-input-container .country-button {
  height: 45px;
  background-color: var(--input-bg) !important;
  border: 1px solid var(--input-stroke) !important;
  border-right: none !important;
  border-radius: var(--rounded-8) 0 0 var(--rounded-8) !important;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}
/* Hover state for the country button */
.phone-input-container .country-button:hover,
.phone-input-container .country-button:focus {
  background-color: var(--neutral-100) !important;
}
/* Focus state for the entire component */
.phone-input-container .form-control:focus {
  border-color: var(--brand) !important;
  // box-shadow: 0 0 0 3px var(--primary-light-white);
}
.phone-input-container .form-control:focus + .country-button {
    border-color: var(--brand) !important;
}
/* --- STATES --- */
/* Error State */
.phone-input-container.error .form-control,
.phone-input-container.error .country-button {
  border-color: var(--danger-600) !important;
}
.phone-input-container.error .form-control:focus {
  box-shadow: 0 0 0 3px var(--danger-focus);
}
.phone-input-container.error .form-control:focus + .country-button {
    border-color: var(--danger-600) !important;
}
/* --- DROPDOWN LIST --- */
.react-tel-input .country-list {
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-4);
  border-radius: var(--rounded-8);
  margin-top: var(--size-4) !important;
}
.react-tel-input .country-list .country {
  color: var(--text-secondary-light);
  transition: background-color 0.2s ease;
}
.react-tel-input .country-list .country:hover,
.react-tel-input .country-list .country.highlight {
  background-color: var(--neutral-100);
  color: var(--text-primary-light);
}
.react-tel-input .country-list .country .dial-code {
  color: var(--brand);
}
.react-tel-input .country-list .search {
   background-color: var(--bg-color);
   padding: var(--size-12) var(--size-12) var(--size-8);
}
.react-tel-input .country-list .search-box {
  width: 100%;
  height: auto;
  font-family: var(--default-font, sans-serif);
  font-size: var(--font-sm);
  padding: var(--size-8) var(--size-12);
  background-color: var(--input-bg);
  color: var(--text-primary-light);
  border: 1px solid var(--input-stroke);
  border-radius: var(--rounded-6);
  transition: border-color 0.2s ease;
}
.react-tel-input .country-list .search-box:focus {
  border-color: var(--brand);
  outline: none;
}
/* --- HELPER TEXTS --- */
.text-danger-600 {
  color: var(--danger-600);
}
.text-success {
  color: var(--success-600);
}
.text-warning {
  color: var(--warning-600);
}
.text-danger-600, .text-success, .text-warning {
  font-size: var(--font-xs);
  font-family: var(--default-font, sans-serif);
}
.d-block {
  display: block;
}
.mt-1 {
  margin-top: var(--size-4);
}
.phone-input-container .form-control{
border-radius: 8px !important;
}
      `}</style>
      {labelName && <label className="form-label">{label}</label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <PhoneInput
            {...field}
            country={initialCountry}
            value={field.value}
            placeholder={placeholder}
            enableSearch={true}
            disableSearchIcon={false}
            containerClass={`phone-input-container ${
              errors[name] ? "error" : ""
            }`}
            inputClass="form-control"
            buttonClass="country-button"
            onKeyDown={(e) => {
              const input = e.target;
              const currentValue = input.value || "";
              const digitsOnly = currentValue.replace(/\D/g, "");
              let maxLength = null;
              if (digitsOnly.startsWith("966")) {
                // Saudi Arabia
                maxLength = 12;
              } else if (digitsOnly.startsWith("971")) {
                // UAE
                maxLength = 12;
              }
              if (maxLength) {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                  "Home",
                  "End",
                ];
                if (
                  !allowedKeys.includes(e.key) &&
                  digitsOnly.length >= maxLength &&
                  /\d/.test(e.key)
                ) {
                  e.preventDefault();
                }
              }
            }}
            onChange={(phone, country) => {
              const currentCountry = country.countryCode.toLowerCase();
              // if(countryCode){
              //   localStorage.setItem('country_code', currentCountry);
              // }
              // Check if country has changed
              if (previousCountryRef.current !== currentCountry) {
                // Country changed - reset to just dial code
                const dialCode = country.dialCode;
                field.onChange(`+${dialCode}`);
                if (externalOnChange) {
                  externalOnChange(`+${dialCode}`);
                }
                // Update previous country
                previousCountryRef.current = currentCountry;
                // Reset phone data
                setPhoneData({
                  phone: "",
                  isValid: false,
                });
                // Reset toast
                setToastShown(false);
                return;
              }
              let fullPhoneNumber = `+${phone}`;
              if (
                country.countryCode.toLowerCase() === "sa" &&
                phone.length > 12
              ) {
                fullPhoneNumber = `+${phone.slice(0, 12)}`;
              } else if (
                country.countryCode.toLowerCase() === "ae" &&
                phone.length > 12
              ) {
                fullPhoneNumber = `+${phone.slice(0, 12)}`;
              }
              field.onChange(fullPhoneNumber);
              if (externalOnChange) {
                externalOnChange(fullPhoneNumber);
              }
              let isValid = false;
              try {
                const parsed = parsePhoneNumberFromString(
                  fullPhoneNumber,
                  country.countryCode.toUpperCase()
                );
                isValid = parsed?.isValid() || false;
              } catch (err) {
                isValid = false;
              }
              setPhoneData({
                phone: fullPhoneNumber,
                isValid,
              });
              if (isValid && !toastShown) {
                handleCustomResponse(
                  "success",
                  `Valid ${country.name} phone number entered!`
                );
                setToastShown(true);
              }
              if (!isValid && toastShown) {
                setToastShown(false);
              }
            }}
            isValid={(inputNumber, country) => {
              try {
                const parsed = parsePhoneNumberFromString(
                  `+${inputNumber}`,
                  country.countryCode.toUpperCase()
                );
                return parsed?.isValid() || false;
              } catch {
                return false;
              }
            }}
            specialLabel=""
            autoFormat={true}
            disableDropdown={false}
            countryCodeEditable={false}
          />
        )}
      />
      {/* {errors[name] && (
        <span className="text-danger-600 d-block mt-1">
          {errors[name].message}
        </span>
      )} */}
      {phoneData.phone && !errors[name] && (
        <small
          className={`d-block mt-1 ${
            phoneData.isValid ? "text-success" : "text-warning"
          }`}
        >
          {phoneData.isValid
            ? ""
            : ""}
        </small>
      )}
    </>
  );
};
export default CustomPhoneInput;